import React from "react"
import { BatchEditEntry } from "../../../Reducers/Client/Interface/BatchEditReducer"
import { Button, Text, Box, Row } from "dash-styled"
import { connect } from "react-redux"
import { State, MainThunkDispatch } from "../../../Reducers"
import {
    clearSelection,
    removeFromSelection,
    addToSelection,
    exitBatchMode
} from "../../../Actions/Client/Interface/BatchEditActions"

interface DispatchProps {
    exitBatchEditMode: () => void
    doAddToSelection: (itemIds: string[]) => void
    removeFromSelection: (itemIds: string[]) => void
    doClearSelection: () => void
}

interface StateProps {
    entry?: BatchEditEntry
}

interface BatchEditAction {
    name: string
    count: number // count of items to which this action is applicable
    onClick: () => void
}

export interface BatchEditSidebarProps {
    id: string
    itemIds: string[]
    actions: BatchEditAction[]
}

type Props = BatchEditSidebarProps & DispatchProps & StateProps

const BatchEditSidebarIsolated = ({
    itemIds,
    entry,
    exitBatchEditMode,
    doAddToSelection,
    doClearSelection,
    actions
}: Props) => {
    if (entry === undefined) return null

    const handleSelectAll = () => doAddToSelection(itemIds)
    const renderAction = ({ name, count, onClick }: BatchEditAction) => {
        const disabled = count === 0

        return (
            <Button
                key={name}
                variant="text"
                color="plain"
                onClick={disabled ? undefined : onClick}
            >
                <Row>
                    <Text
                        component="span"
                        color={disabled ? "gray" : undefined}
                    >
                        {name}
                    </Text>
                    <Text
                        component="span"
                        color={disabled ? "gray" : undefined}
                    >
                        {count}
                    </Text>
                </Row>
            </Button>
        )
    }

    return (
        <div>
            <Button
                variant="contained"
                color="plain"
                onClick={exitBatchEditMode}
                className="mb-4"
            >
                Exit Batch Edit Mode
            </Button>
            <Box textAlign="center" marginBottom="3">
                <Text component="span" color="gray">
                    Selected{" "}
                </Text>
                <Text component="span">{entry.selected.length} items</Text>
            </Box>
            <Button
                variant="contained"
                color="plain"
                onClick={handleSelectAll}
                marginBottom="3"
            >
                Select All
            </Button>
            <Button
                variant="contained"
                color="plain"
                onClick={doClearSelection}
                marginBottom="3"
            >
                Clear Selection
            </Button>
            <Text size="md">Actions</Text>
            {actions.map(renderAction)}
        </div>
    )
}

const mapStateToProps = (
    state: State,
    { id }: BatchEditSidebarProps
): StateProps => {
    return {
        entry: state.client.interface.batchEdit[id]
    }
}

const mapDispatchToProps = (
    dispatch: MainThunkDispatch,
    { id }: BatchEditSidebarProps
): DispatchProps => {
    return {
        exitBatchEditMode: () => dispatch(exitBatchMode(id)),
        doAddToSelection: (itemIds: string[]) =>
            dispatch(addToSelection(id, itemIds)),
        removeFromSelection: (itemIds: string[]) =>
            dispatch(removeFromSelection(id, itemIds)),
        doClearSelection: () => dispatch(clearSelection(id))
    }
}

export const BatchEditSidebar = connect(
    mapStateToProps,
    mapDispatchToProps
)(BatchEditSidebarIsolated)
